import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quality-assuarance',
  templateUrl: './quality-assuarance.component.html',
  styleUrls: ['./quality-assuarance.component.css']
})
export class QualityAssuaranceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
